const isMediaDevicesAvailable = () => {
    return Boolean(navigator.mediaDevices && navigator.mediaDevices.enumerateDevices)
}

export default isMediaDevicesAvailable
